// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_kf-1";
export var quotedThread = "_kf-0";